"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Provider = _interopRequireDefault(require("@react/react-spectrum/Provider"));
var _provider = require("@react-spectrum/provider");
var _themeDefault = require("@react-spectrum/theme-default");
var _themeDark = require("@react-spectrum/theme-dark");
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mobxReact = require("mobx-react");
var _react = _interopRequireWildcard(require("react"));
var _dcCore = require("dc-core");
var _ServiceRegistry = _interopRequireDefault(require("../../util/ServiceRegistry"));
var _ComponentRegistry = _interopRequireDefault(require("../../util/ComponentRegistry"));
var _Events = _interopRequireDefault(require("../../constants/Events"));
var _index = _interopRequireDefault(require("dc-icons/variables/index.css"));
var _class;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ // eslint-disable-next-line
const THEME = {
  LIGHT: "light",
  DARK: "dark",
  AUTO: "auto"
};
const v3Theme = _objectSpread(_objectSpread({}, _themeDefault.theme), {}, {
  dark: _themeDark.theme.light
});
const getTypekitId = appLocale => {
  const typekitIds = {
    "ja-jp": "pcg0npo",
    "ko-kr": "wmm2qek",
    "zh-cn": "giv3kdk",
    "zh-tw": "bvi5ncj"
  };
  return typekitIds[appLocale] || "bxf0ivf";
};
let AdobeDCViewApp = exports.default = (0, _mobxReact.observer)(_class = class AdobeDCViewApp extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.onThemeChange = value => {
      this.setState({
        theme: value === "dark" ? THEME.DARK : THEME.LIGHT
      });
      // change scroll bars color
      document.documentElement.style.setProperty("color-scheme", value);
    };
    this.state = {
      theme: THEME.LIGHT
    };
    const appStore = _ServiceRegistry.default.getService("AppStore");
    this.supportDarkMode = appStore.getConfig().supportDarkMode;
    this.userLocale = appStore.configStore.getConfig().locale;
    this.app = this.getLocalizedApp(this.userLocale);
    _dcCore.providers.theme().then(themeProvider => {
      themeProvider.getTheme({
        controlledValue: appStore.enableModernViewer && this.supportDarkMode ? THEME.AUTO : THEME.LIGHT
      }).then(theme => {
        this.onThemeChange(theme);
      });
      themeProvider.subscribe(this.onThemeChange);
    });
  }
  componentDidMount() {}
  getLocalizedApp(loc) {
    // Localization layer for web app.
    const LocalizableApp = props => /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
      locale: props.locale,
      messages: props.messages
    }, _ComponentRegistry.default.getComponent("AppContainer", props));
    LocalizableApp.propTypes = {
      locale: _propTypes.default.objectOf(_propTypes.default.string).isRequired,
      messages: _propTypes.default.objectOf(_propTypes.default.string).isRequired
    };
    return _dcCore.locale2.withTranslations(LocalizableApp, _ServiceRegistry.default.getService("LocaleService").loadMergedTranslations, {
      locale: loc
    });
  }
  shouldBlockRender() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    return appStore.appRenderingBlocked && !appStore.getConfig().showSimpleLoader;
  }
  log() {
    _dcCore.logging.getLogger("App").error("File preview blocked as preview failed to load");
  }
  getProps() {
    const config = _ServiceRegistry.default.getService("AppStore").getConfig();
    if (config.isViewSDKPublic) {
      const typekitId = getTypekitId(window.userLocale.toLowerCase());
      return {
        typekitId
      };
    }
    return {};
  }
  getDOMId() {
    const config = _ServiceRegistry.default.getService("AppStore").getConfig();
    return config.isViewSDKPublic ? "" : "dc-view-sdk-bundle";
  }
  componentWillUnmount() {
    _ServiceRegistry.default.getService("EventsService").sendEvent(_Events.default.VIEWER_UNMOUNT);
    const fileDownloadAbortable = _ServiceRegistry.default.getService("AppStore").getConfig().fileDownloadAbortable;
    if (fileDownloadAbortable) {
      _ServiceRegistry.default.getService("FileApi").abortFileDownload();
    }
    _dcCore.providers.theme().then(themeProvider => themeProvider.unsubscribe(this.onThemeChange));
  }
  render() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const providerCss = {
      height: "100%"
    };
    const props = this.getProps();
    if (this.shouldBlockRender()) {
      this.log();
      return /*#__PURE__*/_react.default.createElement(_Provider.default, _extends({
        locale: this.userLocale,
        style: providerCss
      }, props, {
        theme: this.state.theme
      }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
    }
    if (appStore.isLBPreset) {
      providerCss.backgroundColor = "transparent";
      if (appStore.enableModernViewer) {
        providerCss.backdropFilter = "blur(4px)";
      }
    }
    const App = this.app;
    const renderWithRSPV2Provider = appStore.getConfig().renderWithV2SpectrumProvider;
    const isolationStyle = appStore.getConfig().isIsolationRequired ? "isolate" : "none";
    const providerV3Props = {
      locale: this.userLocale,
      colorScheme: this.state.theme,
      theme: v3Theme,
      height: "100%",
      scale: "medium",
      UNSAFE_style: {
        isolation: isolationStyle
      }
    };
    if (renderWithRSPV2Provider) {
      return /*#__PURE__*/_react.default.createElement(_provider.Provider, providerV3Props, /*#__PURE__*/_react.default.createElement(_Provider.default, _extends({
        theme: this.state.theme,
        id: this.getDOMId(),
        locale: this.userLocale,
        style: providerCss
      }, props), /*#__PURE__*/_react.default.createElement(App, this.props)));
    }
    return /*#__PURE__*/_react.default.createElement(_provider.Provider, _extends({}, providerV3Props, {
      id: this.getDOMId()
    }), /*#__PURE__*/_react.default.createElement(App, this.props));
  }
}) || _class;